module.exports = __webpack_public_path__ + "media/7a1bcf67ff6ac495c85ce24833cd04f6.52667da9.mp4";